/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MultiPartDetail {
    getFixupPrototypeFunction() { return MultiPartDetail.fixupPrototype; }

    static newInstance(model: Partial<MultiPartDetail>): MultiPartDetail {
        let obj = Object.assign(new MultiPartDetail(), model);
        MultiPartDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MultiPartDetail>): MultiPartDetail {
        if (!model) return null;
        return MultiPartDetail.newInstance(<MultiPartDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MultiPartDetail) {
        if (!obj) return;

        models.MultiPartDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MultiPartDetail): boolean {
        Object.setPrototypeOf(obj, MultiPartDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.part_number === undefined) {
            this.part_number = 0;
        }
    }

    /**
     * Part number of the file part
     */
    part_number: number;

    /**
     * ETag of the uploaded part
     */
    etag: string;

}
